module.exports = __webpack_public_path__ + "static/img/1.2cfcfbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/5/1.png
// module id = 3nTn
// module chunks = 0